module.exports = __webpack_public_path__ + "static/media/saas.e761631d.svg";